import React from 'react';

export interface SidebarContextType {
  isCollapsed: boolean;
  hoveredItemId: string | null;
  isNavigating: boolean;
  toggleSidebar: () => void;
  handleMouseEnter: (itemId: string) => void;
  handleMouseLeave: () => void;
  setNavigating: (navigating: boolean) => void;
}

export const SidebarContext = React.createContext<SidebarContextType | undefined>(undefined);

export function useSidebarContext() {
  const context = React.useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebarContext must be used within a SidebarProvider');
  }
  return context;
}
